import round from "lodash/round";

export const pnlSummaryColumns = [
  {
    title: "Shift",
    dataIndex: "name",
    key: "shift",
    width: 200,
    render: (value) => (value ? value : '--'),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
  {
    title: "Mc/run",
    dataIndex: ["stats", "machine_run"],
    key: "machine_run",
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
  {
    title: "Total Hrs",
    dataIndex: ["stats", "available_hours"],
    key: "available_hours",
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
  {
    title: "Running Hrs",
    dataIndex: ["stats", "running_hours"],
    key: "running_hours",
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    render: (value) => (value ? round(value, 2) : 0),

    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
  {
    title: "Eff(%)",
    dataIndex: ["stats", "efficiency"],
    key: "efficiency",
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
  {
    title: "Prod Eff(%)",
    dataIndex: ["stats", "production_efficiency"],
    key: "production_efficiency",
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
  {
    title: "Production Amount",
    width: 130,
    dataIndex: ["stats", "production_amount"],
    key: "production_amount",
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
  {
    title: "Per Hours",
    dataIndex: ["stats", "per_hour_cost"],
    key: "per_hours",
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
  {
    title: "Sale Profit",
    dataIndex: ["stats", "sale_profit"],
    key: "sale_profit",
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
    {
    title: "Salary Cost",
    dataIndex: ["stats", "salary_amount"],
    key: "sale_profit",
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
    {
    title: "Salary %",
    dataIndex: ["stats", "salary_percent"],
    key: "sale",
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },

  {
    title: "Job Profit",
    dataIndex: ["stats", "job_profit"],
    key: "sale",
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
]

export const pnlManagerShiftMetaColumns = [
  {
    title: "Manager",
    dataIndex: "name",
    key: "manager",
    width: 200,
    render: (value) => {
      return (value ? value : '--')
    },
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
  {
    title: "Production Amount",
    dataIndex: ["shift_meta", "production_amount"],
    key: "shift_meta_production_amount",
    width: 130,
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
    {
    title: "Salary Amount",
    dataIndex: ["shift_meta", "salary_amount"],
    key: "shift_meta_salary_amount",
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    render: (value) => (value ? round(value, 2) : 0),

    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
  {
    title: "Salary %",
    dataIndex: ["shift_meta", "salary_percent"],
    key: "shift_meta_available_hours",
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },

  {
    title: "Job Profit",
    dataIndex: ["shift_meta", "job_profit"],
    key: "shift_meta_job_profit",
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
  {
    title: "Job %",
    dataIndex: ["shift_meta", "job_profit_percent"],
    key: "job_profit",
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
  {
    title: "Sale Profit",
    dataIndex: ["shift_meta", "sale_profit"],
    key: "sale_profit",
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
  {
    title: "Sale Profit %",
    dataIndex: ["shift_meta", "sale_profit_percent"],
    key: "sale_profit_percent",
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
  {
    title: "Net Profit",
    dataIndex: ["shift_meta", "net_profit"],
    key: "sale_profit",
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
  {
    title: "Net Profit %",
    dataIndex: ["shift_meta", "net_profit_percent"],
    key: "sale_profit_percent",
    render: (value) => (value ? round(value, 2) : 0),
    onHeaderCell: () => ({
      style: { padding: "4px", textAlign: "center" },
    }),
    onCell: () => ({
      style: {
        padding: "2px",
        paddingTop: "14px",
        paddingBottom: "14px",
        textAlign: "center",
      },
    }),
  },
]